import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';

/**
 * Select, Dropdown 등 공통으로 사용하는 드롭다운 형태 안의 container UI
 */
export const BaseDropdownContainerUI = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({
  children,
  className,
  ...rest
}, ref) => {
  return <div ref={ref} className={cn('relative z-[500] rounded-sm w-full border border-assistive bg-default shadow-lg focus:!shadow-lg',
  //animation
  //data-state는 radix-ui의 dropdown, select 등에서 제공하는 속성입니다.
  'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', className)} {...rest}>
      {children}
    </div>;
});
BaseDropdownContainerUI.displayName = 'BaseDropdownContainerUI';